import { Rating, RatingProps } from '@mui/material'
import StarIcon from '@mui/icons-material/Star'

export const RatingCustom = ({ value, props }: { value: number; props?: Omit<RatingProps, 'children'> }) => {
  return (
    <Rating
      emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
      precision={0.1}
      value={value}
      readOnly
      size="small"
      {...props}
      sx={{
        '& .MuiRating-icon': {
          color: '#FEB50D',
        },
        '& .MuiRating-iconEmpty': {
          color: '#BBBBBA',
        },
        ...props?.sx,
      }}
    />
  )
}
